import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import {Modal} from 'react-bootstrap';

class BankSign extends Component {

    constructor(props) {
        super(props);

        this.state = {
            show_modal: false,
            selected_bank_url: null,
            example: null
        };

        this.banks = [
            {
                name: "SWEDBANK",
                imageUrl: "/img/banks/swed.png",
                extraClasses: '',
                example: "/img/banks/examples/swed.png",
            },
            {
                name: "NORDEA",
                imageUrl: "/img/banks/Nordea.svg",
                extraClasses: 'bigger-logo'
            },
            {
                name: "DNB",
                imageUrl: "/img/banks/luminor.svg",
                extraClasses: ''
            },
            {
                name: "SEB",
                imageUrl: "/img/banks/seb.png",
                extraClasses: '',
                example: "/img/banks/examples/seb.gif",
            },
            {
                name: "MB",
                imageUrl: "/img/banks/new_medicinos_bankas.png",
                extraClasses: ''
            },
            {
                name: "SB",
                imageUrl: "/img/banks/new_siauliu_bankas.svg",
                extraClasses: 'bigger-logo'
            },
            {
                name: "CITADELE",
                imageUrl: "/img/banks/citadele.png",
                extraClasses: ''
            },
            {
                name: "PAYSERA",
                imageUrl: "/img/banks/paysera.png",
                extraClasses: ''
            },
        ];

        this.callback = this.callback.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    callback(event) {
        let bank_id = event.currentTarget.id;
        let bank_info = this.getBankInfo( bank_id );
        let bankLinkUrl = this.props.bankLinkUrls[bank_id];

        if (bankLinkUrl !== undefined && bankLinkUrl !== null) {
            if (bank_info.example === null || bank_info.example === undefined) {
                if (this.props.consentProcess !== undefined && this.props.consentProcess) {
                    gtm.sendEvent('base', {
                        orderID: this.props.applicationId,
                        event: 'checkoutwaitingforsignature',
                        actionField: { step: 4 },
                        pageTitle: 'waiting for signature',
                        eventId: 232
                    });

                    //new version
                    gtm.sendEvent('base', {
                        event: 'loan_application_customer_data_sigining.started',
                        products: this.props.trackData,
                    }, 2);
                }

                window.location = bankLinkUrl.url;
            } else {
                this.setState({
                    show_modal: true,
                    selected_bank_url: bankLinkUrl.url,
                    example: bank_info.example,
                });
            }
        }
    }

    getBankInfo(bank_id) {
        let needed_bank_info = null;
        this.banks.forEach((bank_info) => {
            if (bank_info.name == bank_id) {
                needed_bank_info = bank_info;
            }
        });

        return needed_bank_info;
    }

    getBanksButtons() {
        let bankButtons = [];

        this.banks.forEach((item) => {
           let bankLinkUrl = this.props.bankLinkUrls[item.name];

           if (bankLinkUrl!== undefined && bankLinkUrl !== null) {
               bankButtons.push(
                   <div className="col-12 col-md-6 col-lg-4 p-3" key={item.name}>
                       <a onClick={this.callback}
                          id={item.name}
                          className={"bank-links__card fake-link " + item.extraClasses}>
                           <img src={item.imageUrl}
                                alt="bank logo"/>
                       </a>
                   </div>
               )
           }
        });

        return bankButtons;
    }

    closeModal() {
        this.setState({
            show_modal: false,
            selected_bank_url: null,
            example: null
        })
    }

    render () {
        return (
            <div className="row">
                {this.getBanksButtons()}
                <Modal className="modal modal--big fade p-md-5 sif"
                       dialogClassName="modal-dialog"
                       id="step_2_3b"
                       show={this.state.show_modal}
                       onHide={this.closeModal}
                >
                    <div className="modal-content p-0">

                        <div className="modal-body p-0">
                            <h4 className="modal__heading p-5">NEPAMIRŠKITE PAŽYMĖTI, KAD SUTINKATE MUMS PERDUOTI SAVO ASMENS KODĄ</h4>
                            <div className="container">
                                <div className="row py-2 border-top border-gray-cloud">
                                    <div className="col-12">
                                        {this.state.example !== null  && <img src={this.state.example} style={{maxWidth: "100%"}}/>}
                                    </div>
                                    <div className="col-12 text-center">
                                        <div className="btn btn-primary" onClick={() => {
                                            window.location = this.state.selected_bank_url
                                        }}>
                                            Pasirašyti
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default withTranslation()(BankSign);
